module.exports = __webpack_public_path__ + "static/media/certificatesIconSVG.c26e109c.svg";